export default "__VITE_ASSET__kyG9YlE2__"